import React, { useEffect, useRef } from 'react';
import Prism from 'prismjs';
import 'prismjs/components/prism-sql';
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/themes/prism.css';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import toastMessage from '../../../utils/toastMessage';
import KubitModal from '../../KubitModal';
import { ModalActions } from '../../KubitModal/KubitModalUI';
import { PrimaryButton, SecondaryButton } from '../../Button';
import styled from 'styled-components';
import { getScrollBarStyles } from '../../../config/styles';
import { theme } from '../../../styles/theme';
import copyTextToClipboard from '../../../utils/copyTextToClipboard';

interface IProps {
  sqlType: string;
  close: () => void;
  headerDisplay: string;
  referenceSql: string;
}

const Container = styled.div`
  pre {
    max-height: 374px;
    border-radius: 2px;
    margin: 0;
    background-color: ${theme.colors.tableHeader};
    color: ${theme.colors.secondary900};
    font-size: 12px;
    overflow: auto;
    ${getScrollBarStyles(4)};
  }
  code[class*='language-'] {
    color: inherit;
    text-shadow: none;
  }
  .token.operator,
  .token.entity,
  .token.url,
  .language-css .token.string,
  .style .token.string {
    background-color: unset;
  }

  .keyword {
    color: #ec5f66;
  }

  .function {
    color: #41acbc;
  }

  .type,
  .number,
  .string {
    color: #0070f5;
  }
`;

const ShowSqlModalDisplay = ({
  sqlType,
  close,
  headerDisplay,
  referenceSql,
}: IProps) => {
  const ref = useRef<HTMLElement>(null);
  const copySqlConfirmation = async () => {
    await copyTextToClipboard(referenceSql);

    toastMessage({
      message: `${sqlType} SQL Copied!`,
      type: 'info',
    });
    close();
  };

  useEffect(() => {
    if (ref.current) {
      Prism.highlightElement(ref.current);
    }
  }, []);

  return (
    <KubitModal
      header={headerDisplay}
      onClose={close}
      maxWidth={820}
      open={true}
    >
      <Container>
        <pre className="line-numbers">
          <code ref={ref} className="language-sql">
            {referenceSql}
          </code>
        </pre>
      </Container>
      <ModalActions>
        <SecondaryButton
          type="button"
          onClick={close}
          trackContext="reports"
          trackAction="copy sql - cancel"
        >
          Cancel
        </SecondaryButton>
        <PrimaryButton
          type="button"
          trackContext="reports"
          trackAction="copy sql"
          onClick={copySqlConfirmation}
        >
          Copy SQL
        </PrimaryButton>
      </ModalActions>
    </KubitModal>
  );
};

export default ShowSqlModalDisplay;
